(function() {
  angular.module('claims')
    .service('claimService', ['$log', '$filter', 'dsoProviderService', function($log, $filter, dsoProviderService) {
      let claimsSearchParams = {};
      let historyPropMap = {refId:'referenceId', eftNumber:'eft'};
      let searchEventNames = ['Member Claim Search','EFT Number Search','Check Number Search','Date Range Search'];
      function criteriaScopeByEvent(eventName) {
        let _scope = { isMemberSearchOpen: eventName === searchEventNames[0],
                       openEFT: eventName === searchEventNames[1],
                       openCheckNumber: eventName === searchEventNames[2],
                       openDateRange: eventName === searchEventNames[3]
                     };
        if (!(_scope.openEFT || _scope.openCheckNumber || _scope.openDateRange)) {
          _scope.isMemberSearchOpen = true;
        }
        return _scope;
      }

      var service = {
        initClaimSearchParams: function() {
          claimsSearchParams = {};
        },
        claimsSearchParams: function(_claimsSearchParams) {
          if (_claimsSearchParams !== undefined) {
            claimsSearchParams = angular.copy(_claimsSearchParams);
          }
          return claimsSearchParams;
        },
        historyToModel: function(historyEventData) {
            let model = _.pick(historyEventData,['checkNumber','dateRangeFrom','dateRangeTo','taxId','city','state','searchType']);
            _.each(historyPropMap, (v,k) => model[v] = historyEventData[k]);
            claimsSearchParams = { model: model,
                                   referenceId: model.referenceId,
                                   status:criteriaScopeByEvent(historyEventData.eventName),
                                   locations: angular.copy(historyEventData.locations)};
        },
        getFilteredTaxIdLocations: function(taxId, selectedLocations) {
           return dsoProviderService.getTaxIdLocations(taxId).then((result) => {
                let locations =  _.map(selectedLocations, (centerId) => {
                  let location = _.find(result.locations,(loc) => {return loc.centerId === centerId;});
                  if (location) {
                    return $filter('location')(location);
                  }
               });
               return locations;
          }, (error) => {
              return [];
          });
        },
        getMemberByRefId: function (refId) {
          return this.associatedMembersPromise.then(function (data) {
            return _.find(data, (m) => {
              return _.find(m.policies, (p) => {
                return p.referenceId == refId;
              });
            });
          });
        },
        checkPoliciesForClaimBlock: function(members) {
            _.each(members, (member, index) =>{
              var policyList = [];
              _.each(member.policies, (policy,index) => {
                var rule = _.find(policy.rules, (r) => r.isClaimBlock);
                if(rule == null || !rule.isClaimBlock) {
                  policyList.push(policy);
                }
                if(rule != null && rule.isClaimBlock) {
                  member.claimBlock = true;
                }
              });
              member.policies = policyList;
            });
            return members;
        }
      };
      return service;
    }]);

})();
